<mat-card appearance="outlined" *ngIf="!!dynamicContent">
  <h2>{{ 'dynamicContent.logo' | translate }}</h2>

  <div class="main-actions">
    <button (click)="chooseFromMediaAssets()" class="ibexfusion-raised-button" mat-button>{{ 'general.selectLogo' | translate }}</button>
  </div>

  <div class="table-header">
    <div class="preview"></div>
    <div class="title">{{ 'general.title' | translate }}</div>
    <div class="date">{{ 'general.created' | translate }}</div>
    <div class="size">{{ 'general.size' | translate }}</div>
    <div class="actions"></div>
  </div>

  <div class="table" *ngIf="dynamicContent?.content?.otherLogo">
    <div class="table-row">
      <div class="preview"><smart-image [url]="dynamicContent.content.otherLogo" class="image"></smart-image></div>
      <div class="title">{{ asset?.title || asset?.originalFileName }}</div>
      <div class="date"><ng-container *ngIf="asset?.created">{{ asset.created | date:'dd.MM.YYYY' }}</ng-container></div>
      <div class="size"><ng-container *ngIf="asset?.fileSize">{{ asset.fileSize | fileSize }}</ng-container></div>
      <div class="actions">
        <button (click)="dynamicContent.content.otherLogo = null; asset = null" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <p *ngIf="!dynamicContent?.content?.otherLogo" class="no-file">{{ 'dynamicContent.noMedia' | translate }}</p>
</mat-card>
